import { FlowDefinition } from "../../core/flows/FlowDefinition";
import { StepDefinition } from "../../core/flows/StepDefinition";
import { bookItAgainStartupStepDefinition } from "../BookItAgain/BookItAgainStartup";
import { bookReturnJourneyStartupStepDefinition } from "../BookReturnJourney/BookReturnJourneyStartup";
import { changeDateStepFlowDefinition } from "../ChangeDate/ChangeDateStartup";
import { journeyPlannerStartupFlowDefinition } from "../JourneyPlanner/JourneyPlannerStartup";
import { manageSeatingStartupStepDefinition } from "../ManageSeating/ManageSeatingStartup";
import { ticketDetailStartupFlowDefinition } from "../TicketDetail/TicketDetailStartup";
import { BookingDetailInitStepDeclaration } from "./Steps/BookingDetailInitStep";
import { BookingDetailStepDeclaration } from "./Steps/BookingDetailStep";
import { BookingDetailTransition } from "./Transition/BookingDetailTransition";
 
 
export const BookingDetailStartupFlow = new FlowDefinition("BookingDetailFlow");
 
BookingDetailStartupFlow.addStep(BookingDetailInitStepDeclaration);
BookingDetailStartupFlow.addStep(BookingDetailStepDeclaration);
BookingDetailStartupFlow.addStep(ticketDetailStartupFlowDefinition);
BookingDetailStartupFlow.addStep(bookItAgainStartupStepDefinition);
BookingDetailStartupFlow.addStep(changeDateStepFlowDefinition);
BookingDetailStartupFlow.addStep(manageSeatingStartupStepDefinition);
BookingDetailStartupFlow.addStep(bookReturnJourneyStartupStepDefinition);
BookingDetailStartupFlow.addStep(journeyPlannerStartupFlowDefinition);

BookingDetailStartupFlow.addLink("BookingDetailInit_Step", "BookingDetail_Step");
BookingDetailStartupFlow.addLink("BookingDetailInit_Step", "BookItAgainFlow");
BookingDetailStartupFlow.addLink("BookingDetailInit_Step", "ChangeDateFlow");
BookingDetailStartupFlow.addLink("BookingDetailInit_Step", "ManageSeatingFlow");
BookingDetailStartupFlow.addLink("BookingDetailInit_Step", "BookReturnJourneyFlow");
BookingDetailStartupFlow.addLink("BookingDetailInit_Step", "JourneyPlannerFlow");
 
 
BookingDetailStartupFlow.addLink("BookingDetail_Step", "TicketDetailFlow");
BookingDetailStartupFlow.addLink("TicketDetailFlow", "BookingDetail_Step");
 
BookingDetailStartupFlow.addTransition(BookingDetailTransition, "BookingDetailInit_Step")
 
BookingDetailStartupFlow.setStartStep("BookingDetailInit_Step");
 
export const bookingDetailStartupFlowDefinition = new StepDefinition({
    stepName: "BookingDetailFlow",
    stepFlow: BookingDetailStartupFlow,
    contextIsolation: false
})